import { day } from '@vrplatform/utils';
import { createContext, useContext } from 'react';

type OwnerStatementSummariesDetailContext = {
  contactId: string | undefined;
  monthRange: `${string}...${string}`;
};

const OwnerStatementSummariesDetailContext = createContext<
  OwnerStatementSummariesDetailContext | undefined
>(undefined);

export const OwnerStatementSummariesDetailContextProvider = ({
  children,
  ...props
}: { children: React.ReactNode } & OwnerStatementSummariesDetailContext) => {
  'use memo';

  return (
    <OwnerStatementSummariesDetailContext.Provider value={props}>
      {children}
    </OwnerStatementSummariesDetailContext.Provider>
  );
};

export const useOwnerStatementSummariesDetailContext = () => {
  const context = useContext(OwnerStatementSummariesDetailContext);
  // if (!context) {
  //   throw new Error(
  //     'useOwnerStatementSummariesDetail must be used within a OwnerStatementSummariesDetailProvider'
  //   );
  // }

  const today = day();
  const startAt = today.startOf('year').yyyymmdd();
  const endAt = today.endOf('year').yyyymmdd();

  return (
    context || { contactId: undefined, monthRange: `${startAt}...${endAt}` }
  );
};
